module.exports = __webpack_public_path__ + "img/logo_internship.135d9cb0.png";